export type DtiPublicApiErrorKind =
  'transport' | 'graphql' | 'contract' | 'aborted' | 'auth';

export type DtiPublicApiDomainAuthMode =
  'entry' | 'authenticated' | 'sessionAware' | 'reference' | 'recovery';

export type DtiPublicApiAuthMode = DtiPublicApiDomainAuthMode;

export type DtiPublicApiRemoteAuthFailureCode =
  | 'UNEXPECTED_AUTH'
  | 'TOKEN_MISSING'
  | 'TOKEN_INVALID'
  | 'TOKEN_EXPIRED'
  | 'UNAUTHENTICATED'
  | 'FORBIDDEN'
  | 'ALREADY_BOOKED';

export type DtiPublicApiAuthFailureReason =
  | 'missing'
  | 'expired'
  | 'malformed'
  | 'session_required'
  | 'http_status'
  | DtiPublicApiRemoteAuthFailureCode;

export type DtiPublicApiPreflightAuthErrorDetails = Readonly<{
  stage: 'preflight';
  mode: DtiPublicApiDomainAuthMode;
  bearerSent: boolean;
  reason: DtiPublicApiAuthFailureReason;
  malformedField?: 'token' | 'expiry';
}>;

export type DtiPublicApiRemoteAuthErrorDetails = Readonly<{
  stage: 'remote';
  mode: DtiPublicApiDomainAuthMode;
  bearerSent: boolean;
  reason: DtiPublicApiAuthFailureReason;
  status?: number;
  code?: DtiPublicApiRemoteAuthFailureCode;
  sessionDisposition?: 'preserve_newer';
}>;

export type DtiPublicApiAuthErrorDetails =
  DtiPublicApiPreflightAuthErrorDetails | DtiPublicApiRemoteAuthErrorDetails;

export class DtiPublicApiError extends Error {
  constructor(
    message: string,
    public readonly kind: DtiPublicApiErrorKind,
    public readonly operationName: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'DtiPublicApiError';
  }
}
